import { type FC } from "react";

import { LegalAuthorityInfoStep } from "./LegalAuthorityInfoStep";

interface LegalAuthorityNoWillStepProps {
  onBack: () => void;
  onContinue: () => void;
}

export const LegalAuthorityNoWillStep: FC<LegalAuthorityNoWillStepProps> = ({
  onBack,
  onContinue,
}) => (
  <LegalAuthorityInfoStep onBack={onBack} onContinue={onContinue}>
    <p>Most adults don't have one. There's a path for this, and it's already mapped.</p>
    <p>When there's no will, state law decides who inherits and who can handle the estate.</p>
    <p>Your next steps are built around those rules, so you don't have to figure them out alone.</p>
  </LegalAuthorityInfoStep>
);
